export default __webpack_public_path__ + "static/media/Internship-Brochure.fec515e1.pdf";